module.exports = (s) => {
  return [
    {
      name: '资产名称',
      value: 'asset_name',
    },
    {
      value: 'micro_app_id',
      props: {
        'render-header': (h) => {
          return h('div', {}, (() => {
            const strategy = {
              'WECHAT_GAME': '小游戏原始id',
              'BYTE_GAME': '小游戏appid',
            };
            return strategy[s.mgType];
          })());
        },
      },
    },
    {
      name: '小游戏资产id',
      value: 'micro_app_instance_id',
    },
    {
      name: '操作',
      width: 90,
      align: 'center',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                s.confirm(row);
              },
            },
          },
          '选择',
        );
        return ele;
      },
    },
  ];
};
